import React from "react";
import { DisplayCurrencyProps, useCurrency } from "./useCurrency.ts";

export default function FormatCurrency(props: DisplayCurrencyProps) {
  const parseCurrency = useCurrency();
  return <>{parseCurrency(props.value, props.options)}</>;
}
